import React, { useContext } from 'react';
import Flag from '../Flag/Flag';
import HeaderContext from './HeaderContext';
import HeaderMegaMenuMenu from './HeaderMegaMenuMenu';
import HeaderFlyoutItem from './HeaderFlyoutItem';
import HeaderFlyoutLocaleForm from './HeaderFlyoutLocaleForm';

const HeaderFlyoutLocale = ({ id }) => {
  const { activeMegaMenu, toggleMegaMenu } = useContext(HeaderContext);
  const title = (
    <>
      <Flag country="gb" />
      {' United Kingdom'}
    </>
  );

  const toggle = () => {
    toggleMegaMenu(id);
  };

  return (
    <HeaderFlyoutItem
      title={title}
      onClick={toggle}
      isDropdown
      isOpen={id == activeMegaMenu}
    >
      <HeaderMegaMenuMenu onClose={toggle} isOpen={id == activeMegaMenu}>
        <HeaderFlyoutLocaleForm />
      </HeaderMegaMenuMenu>
    </HeaderFlyoutItem>
  );
};

export default HeaderFlyoutLocale;
